"use strict";
// tslint:disable
/**
 * Unimaze\'s Registry web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var globalImportUrl = __importStar(require("url"));
var axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
var base_1 = require("./base");
/**
 * ApplicationApi - axios parameter creator
 * @export
 */
exports.ApplicationApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Returning application initialization settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        init: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/application/init";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ApplicationApi - functional programming interface
 * @export
 */
exports.ApplicationApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Returning application initialization settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        init: function (options) {
            var localVarAxiosArgs = exports.ApplicationApiAxiosParamCreator(configuration).init(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ApplicationApi - factory interface
 * @export
 */
exports.ApplicationApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Returning application initialization settings.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        init: function (options) {
            return exports.ApplicationApiFp(configuration).init(options)(axios, basePath);
        },
    };
};
/**
 * ApplicationApi - object-oriented interface
 * @export
 * @class ApplicationApi
 * @extends {BaseAPI}
 */
var ApplicationApi = /** @class */ (function (_super) {
    __extends(ApplicationApi, _super);
    function ApplicationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Returning application initialization settings.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplicationApi
     */
    ApplicationApi.prototype.init = function (options) {
        return exports.ApplicationApiFp(this.configuration).init(options)(this.axios, this.basePath);
    };
    return ApplicationApi;
}(base_1.BaseAPI));
exports.ApplicationApi = ApplicationApi;
/**
 * BackendApi - axios parameter creator
 * @export
 */
exports.BackendApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Gets a pages list of companies and individuals.
         * @param {string} [nameFilter]
         * @param {string} [addressFilter]
         * @param {string} [country]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompaniesAsync: function (nameFilter, addressFilter, country, offset, limit, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/backend/companies";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (nameFilter !== undefined) {
                localVarQueryParameter['NameFilter'] = nameFilter;
            }
            if (addressFilter !== undefined) {
                localVarQueryParameter['AddressFilter'] = addressFilter;
            }
            if (country !== undefined) {
                localVarQueryParameter['Country'] = country;
            }
            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a particular company, by its identifier.
         * @param {string} isoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyByIsoIdentifierAsync: function (isoIdentifier, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'isoIdentifier' is not null or undefined
            if (isoIdentifier === null || isoIdentifier === undefined) {
                throw new base_1.RequiredError('isoIdentifier', 'Required parameter isoIdentifier was null or undefined when calling getCompanyByIsoIdentifierAsync.');
            }
            var localVarPath = "/api/v1/backend/companies/{isoIdentifier}"
                .replace("{" + "isoIdentifier" + "}", encodeURIComponent(String(isoIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * BackendApi - functional programming interface
 * @export
 */
exports.BackendApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Gets a pages list of companies and individuals.
         * @param {string} [nameFilter]
         * @param {string} [addressFilter]
         * @param {string} [country]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompaniesAsync: function (nameFilter, addressFilter, country, offset, limit, options) {
            var localVarAxiosArgs = exports.BackendApiAxiosParamCreator(configuration).getCompaniesAsync(nameFilter, addressFilter, country, offset, limit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Gets a particular company, by its identifier.
         * @param {string} isoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyByIsoIdentifierAsync: function (isoIdentifier, options) {
            var localVarAxiosArgs = exports.BackendApiAxiosParamCreator(configuration).getCompanyByIsoIdentifierAsync(isoIdentifier, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * BackendApi - factory interface
 * @export
 */
exports.BackendApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Gets a pages list of companies and individuals.
         * @param {string} [nameFilter]
         * @param {string} [addressFilter]
         * @param {string} [country]
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompaniesAsync: function (nameFilter, addressFilter, country, offset, limit, options) {
            return exports.BackendApiFp(configuration).getCompaniesAsync(nameFilter, addressFilter, country, offset, limit, options)(axios, basePath);
        },
        /**
         *
         * @summary Gets a particular company, by its identifier.
         * @param {string} isoIdentifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompanyByIsoIdentifierAsync: function (isoIdentifier, options) {
            return exports.BackendApiFp(configuration).getCompanyByIsoIdentifierAsync(isoIdentifier, options)(axios, basePath);
        },
    };
};
/**
 * BackendApi - object-oriented interface
 * @export
 * @class BackendApi
 * @extends {BaseAPI}
 */
var BackendApi = /** @class */ (function (_super) {
    __extends(BackendApi, _super);
    function BackendApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Gets a pages list of companies and individuals.
     * @param {string} [nameFilter]
     * @param {string} [addressFilter]
     * @param {string} [country]
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackendApi
     */
    BackendApi.prototype.getCompaniesAsync = function (nameFilter, addressFilter, country, offset, limit, options) {
        return exports.BackendApiFp(this.configuration).getCompaniesAsync(nameFilter, addressFilter, country, offset, limit, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Gets a particular company, by its identifier.
     * @param {string} isoIdentifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BackendApi
     */
    BackendApi.prototype.getCompanyByIsoIdentifierAsync = function (isoIdentifier, options) {
        return exports.BackendApiFp(this.configuration).getCompanyByIsoIdentifierAsync(isoIdentifier, options)(this.axios, this.basePath);
    };
    return BackendApi;
}(base_1.BaseAPI));
exports.BackendApi = BackendApi;
/**
 * ClassificationsApi - axios parameter creator
 * @export
 */
exports.ClassificationsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Gets all classifications by parent classification code
         * @param {string} code A code within the UNSPS/C classifications, e.g. \&#39;10000000,20000000\&#39;
         * @param {string} [textFilter] Filters search results by title.
         * @param {string} [lang] Translation language, e.g. \&#39;en,is\&#39;. Default is empty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories: function (code, textFilter, lang, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'code' is not null or undefined
            if (code === null || code === undefined) {
                throw new base_1.RequiredError('code', 'Required parameter code was null or undefined when calling getCategories.');
            }
            var localVarPath = "/api/v1/classifications/{code}"
                .replace("{" + "code" + "}", encodeURIComponent(String(code)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (textFilter !== undefined) {
                localVarQueryParameter['textFilter'] = textFilter;
            }
            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets all classifications as tree hierarchy by parent classification code
         * @param {string} code A code within the UNSPS/C classifications, e.g. \&#39;10000000,20000000\&#39;
         * @param {string} [textFilter] Filters search results by title.
         * @param {string} [lang] Translation language, e.g. \&#39;en,is\&#39;. Default is empty.
         * @param {Array<number>} [levels] Define which levels of classfications to search. If empty, searches on all 4 levels (1, 2, 3 and 4)
         * @param {number} [offset] Number of items to skip. Must be a multiple of parameter \&quot;limit\&quot;.
         * @param {number} [limit] Maximum number of items to display on each page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoriesTree: function (code, textFilter, lang, levels, offset, limit, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'code' is not null or undefined
            if (code === null || code === undefined) {
                throw new base_1.RequiredError('code', 'Required parameter code was null or undefined when calling getCategoriesTree.');
            }
            var localVarPath = "/api/v1/classifications/{code}/tree"
                .replace("{" + "code" + "}", encodeURIComponent(String(code)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (textFilter !== undefined) {
                localVarQueryParameter['textFilter'] = textFilter;
            }
            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }
            if (levels) {
                localVarQueryParameter['levels'] = levels;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets all root classifications
         * @param {string} [textFilter] Filters search results by title.
         * @param {string} [lang] Translation language, e.g. \&#39;en,is\&#39;. Default is empty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRootCategories: function (textFilter, lang, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/classifications";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (textFilter !== undefined) {
                localVarQueryParameter['textFilter'] = textFilter;
            }
            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets all classifications as tree hierarchy
         * @param {string} [textFilter] Filters search results by title.
         * @param {string} [lang] Translation language, e.g. \&#39;en,is\&#39;. Default is empty.
         * @param {Array<number>} [levels] Define which levels of classfications to search. If empty, searches on all 4 levels (1, 2, 3 and 4)
         * @param {number} [offset] Number of items to skip. Must be a multiple of parameter \&quot;limit\&quot;.
         * @param {number} [limit] Maximum number of items to display on each page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRootCategoriesTree: function (textFilter, lang, levels, offset, limit, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/classifications/tree";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            if (textFilter !== undefined) {
                localVarQueryParameter['textFilter'] = textFilter;
            }
            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }
            if (levels) {
                localVarQueryParameter['levels'] = levels;
            }
            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ClassificationsApi - functional programming interface
 * @export
 */
exports.ClassificationsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Gets all classifications by parent classification code
         * @param {string} code A code within the UNSPS/C classifications, e.g. \&#39;10000000,20000000\&#39;
         * @param {string} [textFilter] Filters search results by title.
         * @param {string} [lang] Translation language, e.g. \&#39;en,is\&#39;. Default is empty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories: function (code, textFilter, lang, options) {
            var localVarAxiosArgs = exports.ClassificationsApiAxiosParamCreator(configuration).getCategories(code, textFilter, lang, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Gets all classifications as tree hierarchy by parent classification code
         * @param {string} code A code within the UNSPS/C classifications, e.g. \&#39;10000000,20000000\&#39;
         * @param {string} [textFilter] Filters search results by title.
         * @param {string} [lang] Translation language, e.g. \&#39;en,is\&#39;. Default is empty.
         * @param {Array<number>} [levels] Define which levels of classfications to search. If empty, searches on all 4 levels (1, 2, 3 and 4)
         * @param {number} [offset] Number of items to skip. Must be a multiple of parameter \&quot;limit\&quot;.
         * @param {number} [limit] Maximum number of items to display on each page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoriesTree: function (code, textFilter, lang, levels, offset, limit, options) {
            var localVarAxiosArgs = exports.ClassificationsApiAxiosParamCreator(configuration).getCategoriesTree(code, textFilter, lang, levels, offset, limit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Gets all root classifications
         * @param {string} [textFilter] Filters search results by title.
         * @param {string} [lang] Translation language, e.g. \&#39;en,is\&#39;. Default is empty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRootCategories: function (textFilter, lang, options) {
            var localVarAxiosArgs = exports.ClassificationsApiAxiosParamCreator(configuration).getRootCategories(textFilter, lang, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Gets all classifications as tree hierarchy
         * @param {string} [textFilter] Filters search results by title.
         * @param {string} [lang] Translation language, e.g. \&#39;en,is\&#39;. Default is empty.
         * @param {Array<number>} [levels] Define which levels of classfications to search. If empty, searches on all 4 levels (1, 2, 3 and 4)
         * @param {number} [offset] Number of items to skip. Must be a multiple of parameter \&quot;limit\&quot;.
         * @param {number} [limit] Maximum number of items to display on each page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRootCategoriesTree: function (textFilter, lang, levels, offset, limit, options) {
            var localVarAxiosArgs = exports.ClassificationsApiAxiosParamCreator(configuration).getRootCategoriesTree(textFilter, lang, levels, offset, limit, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ClassificationsApi - factory interface
 * @export
 */
exports.ClassificationsApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Gets all classifications by parent classification code
         * @param {string} code A code within the UNSPS/C classifications, e.g. \&#39;10000000,20000000\&#39;
         * @param {string} [textFilter] Filters search results by title.
         * @param {string} [lang] Translation language, e.g. \&#39;en,is\&#39;. Default is empty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories: function (code, textFilter, lang, options) {
            return exports.ClassificationsApiFp(configuration).getCategories(code, textFilter, lang, options)(axios, basePath);
        },
        /**
         *
         * @summary Gets all classifications as tree hierarchy by parent classification code
         * @param {string} code A code within the UNSPS/C classifications, e.g. \&#39;10000000,20000000\&#39;
         * @param {string} [textFilter] Filters search results by title.
         * @param {string} [lang] Translation language, e.g. \&#39;en,is\&#39;. Default is empty.
         * @param {Array<number>} [levels] Define which levels of classfications to search. If empty, searches on all 4 levels (1, 2, 3 and 4)
         * @param {number} [offset] Number of items to skip. Must be a multiple of parameter \&quot;limit\&quot;.
         * @param {number} [limit] Maximum number of items to display on each page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategoriesTree: function (code, textFilter, lang, levels, offset, limit, options) {
            return exports.ClassificationsApiFp(configuration).getCategoriesTree(code, textFilter, lang, levels, offset, limit, options)(axios, basePath);
        },
        /**
         *
         * @summary Gets all root classifications
         * @param {string} [textFilter] Filters search results by title.
         * @param {string} [lang] Translation language, e.g. \&#39;en,is\&#39;. Default is empty.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRootCategories: function (textFilter, lang, options) {
            return exports.ClassificationsApiFp(configuration).getRootCategories(textFilter, lang, options)(axios, basePath);
        },
        /**
         *
         * @summary Gets all classifications as tree hierarchy
         * @param {string} [textFilter] Filters search results by title.
         * @param {string} [lang] Translation language, e.g. \&#39;en,is\&#39;. Default is empty.
         * @param {Array<number>} [levels] Define which levels of classfications to search. If empty, searches on all 4 levels (1, 2, 3 and 4)
         * @param {number} [offset] Number of items to skip. Must be a multiple of parameter \&quot;limit\&quot;.
         * @param {number} [limit] Maximum number of items to display on each page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRootCategoriesTree: function (textFilter, lang, levels, offset, limit, options) {
            return exports.ClassificationsApiFp(configuration).getRootCategoriesTree(textFilter, lang, levels, offset, limit, options)(axios, basePath);
        },
    };
};
/**
 * ClassificationsApi - object-oriented interface
 * @export
 * @class ClassificationsApi
 * @extends {BaseAPI}
 */
var ClassificationsApi = /** @class */ (function (_super) {
    __extends(ClassificationsApi, _super);
    function ClassificationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Gets all classifications by parent classification code
     * @param {string} code A code within the UNSPS/C classifications, e.g. \&#39;10000000,20000000\&#39;
     * @param {string} [textFilter] Filters search results by title.
     * @param {string} [lang] Translation language, e.g. \&#39;en,is\&#39;. Default is empty.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassificationsApi
     */
    ClassificationsApi.prototype.getCategories = function (code, textFilter, lang, options) {
        return exports.ClassificationsApiFp(this.configuration).getCategories(code, textFilter, lang, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Gets all classifications as tree hierarchy by parent classification code
     * @param {string} code A code within the UNSPS/C classifications, e.g. \&#39;10000000,20000000\&#39;
     * @param {string} [textFilter] Filters search results by title.
     * @param {string} [lang] Translation language, e.g. \&#39;en,is\&#39;. Default is empty.
     * @param {Array<number>} [levels] Define which levels of classfications to search. If empty, searches on all 4 levels (1, 2, 3 and 4)
     * @param {number} [offset] Number of items to skip. Must be a multiple of parameter \&quot;limit\&quot;.
     * @param {number} [limit] Maximum number of items to display on each page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassificationsApi
     */
    ClassificationsApi.prototype.getCategoriesTree = function (code, textFilter, lang, levels, offset, limit, options) {
        return exports.ClassificationsApiFp(this.configuration).getCategoriesTree(code, textFilter, lang, levels, offset, limit, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Gets all root classifications
     * @param {string} [textFilter] Filters search results by title.
     * @param {string} [lang] Translation language, e.g. \&#39;en,is\&#39;. Default is empty.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassificationsApi
     */
    ClassificationsApi.prototype.getRootCategories = function (textFilter, lang, options) {
        return exports.ClassificationsApiFp(this.configuration).getRootCategories(textFilter, lang, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Gets all classifications as tree hierarchy
     * @param {string} [textFilter] Filters search results by title.
     * @param {string} [lang] Translation language, e.g. \&#39;en,is\&#39;. Default is empty.
     * @param {Array<number>} [levels] Define which levels of classfications to search. If empty, searches on all 4 levels (1, 2, 3 and 4)
     * @param {number} [offset] Number of items to skip. Must be a multiple of parameter \&quot;limit\&quot;.
     * @param {number} [limit] Maximum number of items to display on each page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClassificationsApi
     */
    ClassificationsApi.prototype.getRootCategoriesTree = function (textFilter, lang, levels, offset, limit, options) {
        return exports.ClassificationsApiFp(this.configuration).getRootCategoriesTree(textFilter, lang, levels, offset, limit, options)(this.axios, this.basePath);
    };
    return ClassificationsApi;
}(base_1.BaseAPI));
exports.ClassificationsApi = ClassificationsApi;
/**
 * CompaniesApi - axios parameter creator
 * @export
 */
exports.CompaniesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Looks for company by its identifier
         * @param {string} userName User name
         * @param {string} [nameFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByNameFilter: function (userName, nameFilter, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'userName' is not null or undefined
            if (userName === null || userName === undefined) {
                throw new base_1.RequiredError('userName', 'Required parameter userName was null or undefined when calling findByNameFilter.');
            }
            var localVarPath = "/api/v1/companies";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (nameFilter !== undefined) {
                localVarQueryParameter['nameFilter'] = nameFilter;
            }
            if (userName !== undefined && userName !== null) {
                localVarHeaderParameter['userName'] = String(userName);
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Looks for company by its identifier
         * @param {string} legalIsoIdentifier
         * @param {string} userName User name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIsoIdentifier: function (legalIsoIdentifier, userName, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'legalIsoIdentifier' is not null or undefined
            if (legalIsoIdentifier === null || legalIsoIdentifier === undefined) {
                throw new base_1.RequiredError('legalIsoIdentifier', 'Required parameter legalIsoIdentifier was null or undefined when calling getByIsoIdentifier.');
            }
            // verify required parameter 'userName' is not null or undefined
            if (userName === null || userName === undefined) {
                throw new base_1.RequiredError('userName', 'Required parameter userName was null or undefined when calling getByIsoIdentifier.');
            }
            var localVarPath = "/api/v1/companies/{legalIsoIdentifier}"
                .replace("{" + "legalIsoIdentifier" + "}", encodeURIComponent(String(legalIsoIdentifier)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (userName !== undefined && userName !== null) {
                localVarHeaderParameter['userName'] = String(userName);
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CompaniesApi - functional programming interface
 * @export
 */
exports.CompaniesApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Looks for company by its identifier
         * @param {string} userName User name
         * @param {string} [nameFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByNameFilter: function (userName, nameFilter, options) {
            var localVarAxiosArgs = exports.CompaniesApiAxiosParamCreator(configuration).findByNameFilter(userName, nameFilter, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Looks for company by its identifier
         * @param {string} legalIsoIdentifier
         * @param {string} userName User name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIsoIdentifier: function (legalIsoIdentifier, userName, options) {
            var localVarAxiosArgs = exports.CompaniesApiAxiosParamCreator(configuration).getByIsoIdentifier(legalIsoIdentifier, userName, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * CompaniesApi - factory interface
 * @export
 */
exports.CompaniesApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Looks for company by its identifier
         * @param {string} userName User name
         * @param {string} [nameFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findByNameFilter: function (userName, nameFilter, options) {
            return exports.CompaniesApiFp(configuration).findByNameFilter(userName, nameFilter, options)(axios, basePath);
        },
        /**
         *
         * @summary Looks for company by its identifier
         * @param {string} legalIsoIdentifier
         * @param {string} userName User name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByIsoIdentifier: function (legalIsoIdentifier, userName, options) {
            return exports.CompaniesApiFp(configuration).getByIsoIdentifier(legalIsoIdentifier, userName, options)(axios, basePath);
        },
    };
};
/**
 * CompaniesApi - object-oriented interface
 * @export
 * @class CompaniesApi
 * @extends {BaseAPI}
 */
var CompaniesApi = /** @class */ (function (_super) {
    __extends(CompaniesApi, _super);
    function CompaniesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Looks for company by its identifier
     * @param {string} userName User name
     * @param {string} [nameFilter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.findByNameFilter = function (userName, nameFilter, options) {
        return exports.CompaniesApiFp(this.configuration).findByNameFilter(userName, nameFilter, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Looks for company by its identifier
     * @param {string} legalIsoIdentifier
     * @param {string} userName User name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    CompaniesApi.prototype.getByIsoIdentifier = function (legalIsoIdentifier, userName, options) {
        return exports.CompaniesApiFp(this.configuration).getByIsoIdentifier(legalIsoIdentifier, userName, options)(this.axios, this.basePath);
    };
    return CompaniesApi;
}(base_1.BaseAPI));
exports.CompaniesApi = CompaniesApi;
/**
 * CountryApi - axios parameter creator
 * @export
 */
exports.CountryApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Gets all countries.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/countries";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets all country validations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryValidations: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/countryValidations";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * CountryApi - functional programming interface
 * @export
 */
exports.CountryApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Gets all countries.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries: function (options) {
            var localVarAxiosArgs = exports.CountryApiAxiosParamCreator(configuration).getCountries(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Gets all country validations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryValidations: function (options) {
            var localVarAxiosArgs = exports.CountryApiAxiosParamCreator(configuration).getCountryValidations(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * CountryApi - factory interface
 * @export
 */
exports.CountryApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Gets all countries.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountries: function (options) {
            return exports.CountryApiFp(configuration).getCountries(options)(axios, basePath);
        },
        /**
         *
         * @summary Gets all country validations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCountryValidations: function (options) {
            return exports.CountryApiFp(configuration).getCountryValidations(options)(axios, basePath);
        },
    };
};
/**
 * CountryApi - object-oriented interface
 * @export
 * @class CountryApi
 * @extends {BaseAPI}
 */
var CountryApi = /** @class */ (function (_super) {
    __extends(CountryApi, _super);
    function CountryApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Gets all countries.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountryApi
     */
    CountryApi.prototype.getCountries = function (options) {
        return exports.CountryApiFp(this.configuration).getCountries(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Gets all country validations.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CountryApi
     */
    CountryApi.prototype.getCountryValidations = function (options) {
        return exports.CountryApiFp(this.configuration).getCountryValidations(options)(this.axios, this.basePath);
    };
    return CountryApi;
}(base_1.BaseAPI));
exports.CountryApi = CountryApi;
/**
 * DocumentsApi - axios parameter creator
 * @export
 */
exports.DocumentsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Gets all business documents.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/documents";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * DocumentsApi - functional programming interface
 * @export
 */
exports.DocumentsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Gets all business documents.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (options) {
            var localVarAxiosArgs = exports.DocumentsApiAxiosParamCreator(configuration).get(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * DocumentsApi - factory interface
 * @export
 */
exports.DocumentsApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Gets all business documents.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (options) {
            return exports.DocumentsApiFp(configuration).get(options)(axios, basePath);
        },
    };
};
/**
 * DocumentsApi - object-oriented interface
 * @export
 * @class DocumentsApi
 * @extends {BaseAPI}
 */
var DocumentsApi = /** @class */ (function (_super) {
    __extends(DocumentsApi, _super);
    function DocumentsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Gets all business documents.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentsApi
     */
    DocumentsApi.prototype.get = function (options) {
        return exports.DocumentsApiFp(this.configuration).get(options)(this.axios, this.basePath);
    };
    return DocumentsApi;
}(base_1.BaseAPI));
exports.DocumentsApi = DocumentsApi;
/**
 * ParticipantIdentifierTypesApi - axios parameter creator
 * @export
 */
exports.ParticipantIdentifierTypesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Gets all participant identifier types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/participant-identifier-types";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ParticipantIdentifierTypesApi - functional programming interface
 * @export
 */
exports.ParticipantIdentifierTypesApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Gets all participant identifier types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (options) {
            var localVarAxiosArgs = exports.ParticipantIdentifierTypesApiAxiosParamCreator(configuration).get(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ParticipantIdentifierTypesApi - factory interface
 * @export
 */
exports.ParticipantIdentifierTypesApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Gets all participant identifier types.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (options) {
            return exports.ParticipantIdentifierTypesApiFp(configuration).get(options)(axios, basePath);
        },
    };
};
/**
 * ParticipantIdentifierTypesApi - object-oriented interface
 * @export
 * @class ParticipantIdentifierTypesApi
 * @extends {BaseAPI}
 */
var ParticipantIdentifierTypesApi = /** @class */ (function (_super) {
    __extends(ParticipantIdentifierTypesApi, _super);
    function ParticipantIdentifierTypesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Gets all participant identifier types.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantIdentifierTypesApi
     */
    ParticipantIdentifierTypesApi.prototype.get = function (options) {
        return exports.ParticipantIdentifierTypesApiFp(this.configuration).get(options)(this.axios, this.basePath);
    };
    return ParticipantIdentifierTypesApi;
}(base_1.BaseAPI));
exports.ParticipantIdentifierTypesApi = ParticipantIdentifierTypesApi;
/**
 * ParticipantsApi - axios parameter creator
 * @export
 */
exports.ParticipantsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Register a transaction.
         * @param {string} isoNumber
         * @param {string} transactionKeyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAs2TransactionToParticipant: function (isoNumber, transactionKeyName, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'isoNumber' is not null or undefined
            if (isoNumber === null || isoNumber === undefined) {
                throw new base_1.RequiredError('isoNumber', 'Required parameter isoNumber was null or undefined when calling addAs2TransactionToParticipant.');
            }
            // verify required parameter 'transactionKeyName' is not null or undefined
            if (transactionKeyName === null || transactionKeyName === undefined) {
                throw new base_1.RequiredError('transactionKeyName', 'Required parameter transactionKeyName was null or undefined when calling addAs2TransactionToParticipant.');
            }
            var localVarPath = "/api/v1/participants/{isoNumber}/as2/transactions/{transactionKeyName}"
                .replace("{" + "isoNumber" + "}", encodeURIComponent(String(isoNumber)))
                .replace("{" + "transactionKeyName" + "}", encodeURIComponent(String(transactionKeyName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Register a transaction.
         * @param {string} isoNumber
         * @param {string} transactionKeyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAs4TransactionToParticipant: function (isoNumber, transactionKeyName, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'isoNumber' is not null or undefined
            if (isoNumber === null || isoNumber === undefined) {
                throw new base_1.RequiredError('isoNumber', 'Required parameter isoNumber was null or undefined when calling addAs4TransactionToParticipant.');
            }
            // verify required parameter 'transactionKeyName' is not null or undefined
            if (transactionKeyName === null || transactionKeyName === undefined) {
                throw new base_1.RequiredError('transactionKeyName', 'Required parameter transactionKeyName was null or undefined when calling addAs4TransactionToParticipant.');
            }
            var localVarPath = "/api/v1/participants/{isoNumber}/as4/transactions/{transactionKeyName}"
                .replace("{" + "isoNumber" + "}", encodeURIComponent(String(isoNumber)))
                .replace("{" + "transactionKeyName" + "}", encodeURIComponent(String(transactionKeyName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Puts a participant business receiver requirements by iso number and transaction group.
         * @param {string} isoNumber
         * @param {string} transactionGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParticipantReceiverRequirementsByTransactionGroupAndIsoNumber: function (isoNumber, transactionGroup, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'isoNumber' is not null or undefined
            if (isoNumber === null || isoNumber === undefined) {
                throw new base_1.RequiredError('isoNumber', 'Required parameter isoNumber was null or undefined when calling deleteParticipantReceiverRequirementsByTransactionGroupAndIsoNumber.');
            }
            // verify required parameter 'transactionGroup' is not null or undefined
            if (transactionGroup === null || transactionGroup === undefined) {
                throw new base_1.RequiredError('transactionGroup', 'Required parameter transactionGroup was null or undefined when calling deleteParticipantReceiverRequirementsByTransactionGroupAndIsoNumber.');
            }
            var localVarPath = "/api/v1/participants/{isoNumber}/transaction-groups/{transactionGroup}/receiver-requirements"
                .replace("{" + "isoNumber" + "}", encodeURIComponent(String(isoNumber)))
                .replace("{" + "transactionGroup" + "}", encodeURIComponent(String(transactionGroup)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets all registered transactions on as2.
         * @param {string} isoNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAs2ParticipantTransactions: function (isoNumber, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'isoNumber' is not null or undefined
            if (isoNumber === null || isoNumber === undefined) {
                throw new base_1.RequiredError('isoNumber', 'Required parameter isoNumber was null or undefined when calling getAllAs2ParticipantTransactions.');
            }
            var localVarPath = "/api/v1/participants/{isoNumber}/as2/transactions"
                .replace("{" + "isoNumber" + "}", encodeURIComponent(String(isoNumber)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets all registered transactions on as4.
         * @param {string} isoNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAs4ParticipantTransactions: function (isoNumber, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'isoNumber' is not null or undefined
            if (isoNumber === null || isoNumber === undefined) {
                throw new base_1.RequiredError('isoNumber', 'Required parameter isoNumber was null or undefined when calling getAllAs4ParticipantTransactions.');
            }
            var localVarPath = "/api/v1/participants/{isoNumber}/as4/transactions"
                .replace("{" + "isoNumber" + "}", encodeURIComponent(String(isoNumber)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets all registered transactions of a profile.
         * @param {string} isoNumber
         * @param {string} profileKeyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllParticipantTransactionsByProfile: function (isoNumber, profileKeyName, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'isoNumber' is not null or undefined
            if (isoNumber === null || isoNumber === undefined) {
                throw new base_1.RequiredError('isoNumber', 'Required parameter isoNumber was null or undefined when calling getAllParticipantTransactionsByProfile.');
            }
            // verify required parameter 'profileKeyName' is not null or undefined
            if (profileKeyName === null || profileKeyName === undefined) {
                throw new base_1.RequiredError('profileKeyName', 'Required parameter profileKeyName was null or undefined when calling getAllParticipantTransactionsByProfile.');
            }
            var localVarPath = "/api/v1/participants/{isoNumber}/profiles/{profileKeyName}/transactions"
                .replace("{" + "isoNumber" + "}", encodeURIComponent(String(isoNumber)))
                .replace("{" + "profileKeyName" + "}", encodeURIComponent(String(profileKeyName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get participant information.
         * @param {string} isoNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipant: function (isoNumber, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'isoNumber' is not null or undefined
            if (isoNumber === null || isoNumber === undefined) {
                throw new base_1.RequiredError('isoNumber', 'Required parameter isoNumber was null or undefined when calling getParticipant.');
            }
            var localVarPath = "/api/v1/participants/{isoNumber}"
                .replace("{" + "isoNumber" + "}", encodeURIComponent(String(isoNumber)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a participant business receiver requirements by iso number and transaction group.
         * @param {string} isoNumber
         * @param {string} transactionGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipantReceiverRequirementsByTransactionGroupAndIsoNumber: function (isoNumber, transactionGroup, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'isoNumber' is not null or undefined
            if (isoNumber === null || isoNumber === undefined) {
                throw new base_1.RequiredError('isoNumber', 'Required parameter isoNumber was null or undefined when calling getParticipantReceiverRequirementsByTransactionGroupAndIsoNumber.');
            }
            // verify required parameter 'transactionGroup' is not null or undefined
            if (transactionGroup === null || transactionGroup === undefined) {
                throw new base_1.RequiredError('transactionGroup', 'Required parameter transactionGroup was null or undefined when calling getParticipantReceiverRequirementsByTransactionGroupAndIsoNumber.');
            }
            var localVarPath = "/api/v1/participants/{isoNumber}/transaction-groups/{transactionGroup}/receiver-requirements"
                .replace("{" + "isoNumber" + "}", encodeURIComponent(String(isoNumber)))
                .replace("{" + "transactionGroup" + "}", encodeURIComponent(String(transactionGroup)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a participant business registration by iso number.
         * @param {string} isoNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipantRegistrationByIsoNumber: function (isoNumber, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'isoNumber' is not null or undefined
            if (isoNumber === null || isoNumber === undefined) {
                throw new base_1.RequiredError('isoNumber', 'Required parameter isoNumber was null or undefined when calling getParticipantRegistrationByIsoNumber.');
            }
            var localVarPath = "/api/v1/participants/{isoNumber}/registrations"
                .replace("{" + "isoNumber" + "}", encodeURIComponent(String(isoNumber)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a participant receiver requirement schematrons information by iso number and transaction.
         * @param {string} isoNumber
         * @param {string} transactionKeyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipantSchematronInformation: function (isoNumber, transactionKeyName, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'isoNumber' is not null or undefined
            if (isoNumber === null || isoNumber === undefined) {
                throw new base_1.RequiredError('isoNumber', 'Required parameter isoNumber was null or undefined when calling getParticipantSchematronInformation.');
            }
            // verify required parameter 'transactionKeyName' is not null or undefined
            if (transactionKeyName === null || transactionKeyName === undefined) {
                throw new base_1.RequiredError('transactionKeyName', 'Required parameter transactionKeyName was null or undefined when calling getParticipantSchematronInformation.');
            }
            var localVarPath = "/api/v1/participants/{isoNumber}/transactions/{transactionKeyName}/schematrons"
                .replace("{" + "isoNumber" + "}", encodeURIComponent(String(isoNumber)))
                .replace("{" + "transactionKeyName" + "}", encodeURIComponent(String(transactionKeyName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Get a participant receiver requirement schematron payload by iso number and transaction.
         * @param {string} isoNumber
         * @param {string} transactionKeyName
         * @param {string} indexOrName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipantSchematronPayload: function (isoNumber, transactionKeyName, indexOrName, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'isoNumber' is not null or undefined
            if (isoNumber === null || isoNumber === undefined) {
                throw new base_1.RequiredError('isoNumber', 'Required parameter isoNumber was null or undefined when calling getParticipantSchematronPayload.');
            }
            // verify required parameter 'transactionKeyName' is not null or undefined
            if (transactionKeyName === null || transactionKeyName === undefined) {
                throw new base_1.RequiredError('transactionKeyName', 'Required parameter transactionKeyName was null or undefined when calling getParticipantSchematronPayload.');
            }
            // verify required parameter 'indexOrName' is not null or undefined
            if (indexOrName === null || indexOrName === undefined) {
                throw new base_1.RequiredError('indexOrName', 'Required parameter indexOrName was null or undefined when calling getParticipantSchematronPayload.');
            }
            var localVarPath = "/api/v1/participants/{isoNumber}/transactions/{transactionKeyName}/schematrons/{indexOrName}/payload"
                .replace("{" + "isoNumber" + "}", encodeURIComponent(String(isoNumber)))
                .replace("{" + "transactionKeyName" + "}", encodeURIComponent(String(transactionKeyName)))
                .replace("{" + "indexOrName" + "}", encodeURIComponent(String(indexOrName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Puts a participant business receiver requirements by iso number and transaction group.
         * @param {string} isoNumber
         * @param {string} transactionGroup
         * @param {ReceiverRequirementsMetadata} [receiverRequirements]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putParticipantReceiverRequirementsByTransactionGroupAndIsoNumber: function (isoNumber, transactionGroup, receiverRequirements, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'isoNumber' is not null or undefined
            if (isoNumber === null || isoNumber === undefined) {
                throw new base_1.RequiredError('isoNumber', 'Required parameter isoNumber was null or undefined when calling putParticipantReceiverRequirementsByTransactionGroupAndIsoNumber.');
            }
            // verify required parameter 'transactionGroup' is not null or undefined
            if (transactionGroup === null || transactionGroup === undefined) {
                throw new base_1.RequiredError('transactionGroup', 'Required parameter transactionGroup was null or undefined when calling putParticipantReceiverRequirementsByTransactionGroupAndIsoNumber.');
            }
            var localVarPath = "/api/v1/participants/{isoNumber}/transaction-groups/{transactionGroup}/receiver-requirements"
                .replace("{" + "isoNumber" + "}", encodeURIComponent(String(isoNumber)))
                .replace("{" + "transactionGroup" + "}", encodeURIComponent(String(transactionGroup)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json';
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = (typeof receiverRequirements !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data = needsSerialization ? JSON.stringify(receiverRequirements !== undefined ? receiverRequirements : {}) : (receiverRequirements || "");
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Register a participant.
         * @param {string} isoNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerParticipant: function (isoNumber, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'isoNumber' is not null or undefined
            if (isoNumber === null || isoNumber === undefined) {
                throw new base_1.RequiredError('isoNumber', 'Required parameter isoNumber was null or undefined when calling registerParticipant.');
            }
            var localVarPath = "/api/v1/participants/{isoNumber}"
                .replace("{" + "isoNumber" + "}", encodeURIComponent(String(isoNumber)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will be deprecated later.
         * @summary Registers all transactions of a profile.
         * @param {string} isoNumber
         * @param {string} profileKeyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerTransactionsByProfile: function (isoNumber, profileKeyName, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'isoNumber' is not null or undefined
            if (isoNumber === null || isoNumber === undefined) {
                throw new base_1.RequiredError('isoNumber', 'Required parameter isoNumber was null or undefined when calling registerTransactionsByProfile.');
            }
            // verify required parameter 'profileKeyName' is not null or undefined
            if (profileKeyName === null || profileKeyName === undefined) {
                throw new base_1.RequiredError('profileKeyName', 'Required parameter profileKeyName was null or undefined when calling registerTransactionsByProfile.');
            }
            var localVarPath = "/api/v1/participants/{isoNumber}/profiles/{profileKeyName}/transactions"
                .replace("{" + "isoNumber" + "}", encodeURIComponent(String(isoNumber)))
                .replace("{" + "profileKeyName" + "}", encodeURIComponent(String(profileKeyName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'PUT' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Remove all registered transactions.
         * @param {string} isoNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAllParticipantTransactions: function (isoNumber, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'isoNumber' is not null or undefined
            if (isoNumber === null || isoNumber === undefined) {
                throw new base_1.RequiredError('isoNumber', 'Required parameter isoNumber was null or undefined when calling removeAllParticipantTransactions.');
            }
            var localVarPath = "/api/v1/participants/{isoNumber}/transactions"
                .replace("{" + "isoNumber" + "}", encodeURIComponent(String(isoNumber)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Remove transaction for participant.
         * @param {string} isoNumber
         * @param {string} transactionKeyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAs2ParticipantTransactionsByTransactionKey: function (isoNumber, transactionKeyName, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'isoNumber' is not null or undefined
            if (isoNumber === null || isoNumber === undefined) {
                throw new base_1.RequiredError('isoNumber', 'Required parameter isoNumber was null or undefined when calling removeAs2ParticipantTransactionsByTransactionKey.');
            }
            // verify required parameter 'transactionKeyName' is not null or undefined
            if (transactionKeyName === null || transactionKeyName === undefined) {
                throw new base_1.RequiredError('transactionKeyName', 'Required parameter transactionKeyName was null or undefined when calling removeAs2ParticipantTransactionsByTransactionKey.');
            }
            var localVarPath = "/api/v1/participants/{isoNumber}/as2/transactions/{transactionKeyName}"
                .replace("{" + "isoNumber" + "}", encodeURIComponent(String(isoNumber)))
                .replace("{" + "transactionKeyName" + "}", encodeURIComponent(String(transactionKeyName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Remove transaction for participant.
         * @param {string} isoNumber
         * @param {string} transactionKeyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAs4ParticipantTransactionsByTransactionKey: function (isoNumber, transactionKeyName, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'isoNumber' is not null or undefined
            if (isoNumber === null || isoNumber === undefined) {
                throw new base_1.RequiredError('isoNumber', 'Required parameter isoNumber was null or undefined when calling removeAs4ParticipantTransactionsByTransactionKey.');
            }
            // verify required parameter 'transactionKeyName' is not null or undefined
            if (transactionKeyName === null || transactionKeyName === undefined) {
                throw new base_1.RequiredError('transactionKeyName', 'Required parameter transactionKeyName was null or undefined when calling removeAs4ParticipantTransactionsByTransactionKey.');
            }
            var localVarPath = "/api/v1/participants/{isoNumber}/as4/transactions/{transactionKeyName}"
                .replace("{" + "isoNumber" + "}", encodeURIComponent(String(isoNumber)))
                .replace("{" + "transactionKeyName" + "}", encodeURIComponent(String(transactionKeyName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Remove all transaction registrations of a profile.
         * @param {string} isoNumber
         * @param {string} profileKeyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeParticipantTransactionsByProfile: function (isoNumber, profileKeyName, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'isoNumber' is not null or undefined
            if (isoNumber === null || isoNumber === undefined) {
                throw new base_1.RequiredError('isoNumber', 'Required parameter isoNumber was null or undefined when calling removeParticipantTransactionsByProfile.');
            }
            // verify required parameter 'profileKeyName' is not null or undefined
            if (profileKeyName === null || profileKeyName === undefined) {
                throw new base_1.RequiredError('profileKeyName', 'Required parameter profileKeyName was null or undefined when calling removeParticipantTransactionsByProfile.');
            }
            var localVarPath = "/api/v1/participants/{isoNumber}/profiles/{profileKeyName}/transactions"
                .replace("{" + "isoNumber" + "}", encodeURIComponent(String(isoNumber)))
                .replace("{" + "profileKeyName" + "}", encodeURIComponent(String(profileKeyName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Unregister and deletes participant.
         * @param {string} isoNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unregisterParticipant: function (isoNumber, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'isoNumber' is not null or undefined
            if (isoNumber === null || isoNumber === undefined) {
                throw new base_1.RequiredError('isoNumber', 'Required parameter isoNumber was null or undefined when calling unregisterParticipant.');
            }
            var localVarPath = "/api/v1/participants/{isoNumber}"
                .replace("{" + "isoNumber" + "}", encodeURIComponent(String(isoNumber)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'DELETE' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            // authentication bearer required
            if (configuration && configuration.apiKey) {
                var localVarApiKeyValue = typeof configuration.apiKey === 'function'
                    ? configuration.apiKey("Authorization")
                    : configuration.apiKey;
                localVarHeaderParameter["Authorization"] = localVarApiKeyValue;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ParticipantsApi - functional programming interface
 * @export
 */
exports.ParticipantsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Register a transaction.
         * @param {string} isoNumber
         * @param {string} transactionKeyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAs2TransactionToParticipant: function (isoNumber, transactionKeyName, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).addAs2TransactionToParticipant(isoNumber, transactionKeyName, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Register a transaction.
         * @param {string} isoNumber
         * @param {string} transactionKeyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAs4TransactionToParticipant: function (isoNumber, transactionKeyName, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).addAs4TransactionToParticipant(isoNumber, transactionKeyName, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Puts a participant business receiver requirements by iso number and transaction group.
         * @param {string} isoNumber
         * @param {string} transactionGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParticipantReceiverRequirementsByTransactionGroupAndIsoNumber: function (isoNumber, transactionGroup, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).deleteParticipantReceiverRequirementsByTransactionGroupAndIsoNumber(isoNumber, transactionGroup, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Gets all registered transactions on as2.
         * @param {string} isoNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAs2ParticipantTransactions: function (isoNumber, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).getAllAs2ParticipantTransactions(isoNumber, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Gets all registered transactions on as4.
         * @param {string} isoNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAs4ParticipantTransactions: function (isoNumber, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).getAllAs4ParticipantTransactions(isoNumber, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Gets all registered transactions of a profile.
         * @param {string} isoNumber
         * @param {string} profileKeyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllParticipantTransactionsByProfile: function (isoNumber, profileKeyName, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).getAllParticipantTransactionsByProfile(isoNumber, profileKeyName, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get participant information.
         * @param {string} isoNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipant: function (isoNumber, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).getParticipant(isoNumber, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get a participant business receiver requirements by iso number and transaction group.
         * @param {string} isoNumber
         * @param {string} transactionGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipantReceiverRequirementsByTransactionGroupAndIsoNumber: function (isoNumber, transactionGroup, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).getParticipantReceiverRequirementsByTransactionGroupAndIsoNumber(isoNumber, transactionGroup, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get a participant business registration by iso number.
         * @param {string} isoNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipantRegistrationByIsoNumber: function (isoNumber, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).getParticipantRegistrationByIsoNumber(isoNumber, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get a participant receiver requirement schematrons information by iso number and transaction.
         * @param {string} isoNumber
         * @param {string} transactionKeyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipantSchematronInformation: function (isoNumber, transactionKeyName, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).getParticipantSchematronInformation(isoNumber, transactionKeyName, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Get a participant receiver requirement schematron payload by iso number and transaction.
         * @param {string} isoNumber
         * @param {string} transactionKeyName
         * @param {string} indexOrName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipantSchematronPayload: function (isoNumber, transactionKeyName, indexOrName, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).getParticipantSchematronPayload(isoNumber, transactionKeyName, indexOrName, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Puts a participant business receiver requirements by iso number and transaction group.
         * @param {string} isoNumber
         * @param {string} transactionGroup
         * @param {ReceiverRequirementsMetadata} [receiverRequirements]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putParticipantReceiverRequirementsByTransactionGroupAndIsoNumber: function (isoNumber, transactionGroup, receiverRequirements, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).putParticipantReceiverRequirementsByTransactionGroupAndIsoNumber(isoNumber, transactionGroup, receiverRequirements, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Register a participant.
         * @param {string} isoNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerParticipant: function (isoNumber, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).registerParticipant(isoNumber, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Will be deprecated later.
         * @summary Registers all transactions of a profile.
         * @param {string} isoNumber
         * @param {string} profileKeyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerTransactionsByProfile: function (isoNumber, profileKeyName, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).registerTransactionsByProfile(isoNumber, profileKeyName, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Remove all registered transactions.
         * @param {string} isoNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAllParticipantTransactions: function (isoNumber, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).removeAllParticipantTransactions(isoNumber, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Remove transaction for participant.
         * @param {string} isoNumber
         * @param {string} transactionKeyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAs2ParticipantTransactionsByTransactionKey: function (isoNumber, transactionKeyName, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).removeAs2ParticipantTransactionsByTransactionKey(isoNumber, transactionKeyName, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Remove transaction for participant.
         * @param {string} isoNumber
         * @param {string} transactionKeyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAs4ParticipantTransactionsByTransactionKey: function (isoNumber, transactionKeyName, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).removeAs4ParticipantTransactionsByTransactionKey(isoNumber, transactionKeyName, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Remove all transaction registrations of a profile.
         * @param {string} isoNumber
         * @param {string} profileKeyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeParticipantTransactionsByProfile: function (isoNumber, profileKeyName, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).removeParticipantTransactionsByProfile(isoNumber, profileKeyName, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Unregister and deletes participant.
         * @param {string} isoNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unregisterParticipant: function (isoNumber, options) {
            var localVarAxiosArgs = exports.ParticipantsApiAxiosParamCreator(configuration).unregisterParticipant(isoNumber, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ParticipantsApi - factory interface
 * @export
 */
exports.ParticipantsApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Register a transaction.
         * @param {string} isoNumber
         * @param {string} transactionKeyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAs2TransactionToParticipant: function (isoNumber, transactionKeyName, options) {
            return exports.ParticipantsApiFp(configuration).addAs2TransactionToParticipant(isoNumber, transactionKeyName, options)(axios, basePath);
        },
        /**
         *
         * @summary Register a transaction.
         * @param {string} isoNumber
         * @param {string} transactionKeyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addAs4TransactionToParticipant: function (isoNumber, transactionKeyName, options) {
            return exports.ParticipantsApiFp(configuration).addAs4TransactionToParticipant(isoNumber, transactionKeyName, options)(axios, basePath);
        },
        /**
         *
         * @summary Puts a participant business receiver requirements by iso number and transaction group.
         * @param {string} isoNumber
         * @param {string} transactionGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteParticipantReceiverRequirementsByTransactionGroupAndIsoNumber: function (isoNumber, transactionGroup, options) {
            return exports.ParticipantsApiFp(configuration).deleteParticipantReceiverRequirementsByTransactionGroupAndIsoNumber(isoNumber, transactionGroup, options)(axios, basePath);
        },
        /**
         *
         * @summary Gets all registered transactions on as2.
         * @param {string} isoNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAs2ParticipantTransactions: function (isoNumber, options) {
            return exports.ParticipantsApiFp(configuration).getAllAs2ParticipantTransactions(isoNumber, options)(axios, basePath);
        },
        /**
         *
         * @summary Gets all registered transactions on as4.
         * @param {string} isoNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllAs4ParticipantTransactions: function (isoNumber, options) {
            return exports.ParticipantsApiFp(configuration).getAllAs4ParticipantTransactions(isoNumber, options)(axios, basePath);
        },
        /**
         *
         * @summary Gets all registered transactions of a profile.
         * @param {string} isoNumber
         * @param {string} profileKeyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllParticipantTransactionsByProfile: function (isoNumber, profileKeyName, options) {
            return exports.ParticipantsApiFp(configuration).getAllParticipantTransactionsByProfile(isoNumber, profileKeyName, options)(axios, basePath);
        },
        /**
         *
         * @summary Get participant information.
         * @param {string} isoNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipant: function (isoNumber, options) {
            return exports.ParticipantsApiFp(configuration).getParticipant(isoNumber, options)(axios, basePath);
        },
        /**
         *
         * @summary Get a participant business receiver requirements by iso number and transaction group.
         * @param {string} isoNumber
         * @param {string} transactionGroup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipantReceiverRequirementsByTransactionGroupAndIsoNumber: function (isoNumber, transactionGroup, options) {
            return exports.ParticipantsApiFp(configuration).getParticipantReceiverRequirementsByTransactionGroupAndIsoNumber(isoNumber, transactionGroup, options)(axios, basePath);
        },
        /**
         *
         * @summary Get a participant business registration by iso number.
         * @param {string} isoNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipantRegistrationByIsoNumber: function (isoNumber, options) {
            return exports.ParticipantsApiFp(configuration).getParticipantRegistrationByIsoNumber(isoNumber, options)(axios, basePath);
        },
        /**
         *
         * @summary Get a participant receiver requirement schematrons information by iso number and transaction.
         * @param {string} isoNumber
         * @param {string} transactionKeyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipantSchematronInformation: function (isoNumber, transactionKeyName, options) {
            return exports.ParticipantsApiFp(configuration).getParticipantSchematronInformation(isoNumber, transactionKeyName, options)(axios, basePath);
        },
        /**
         *
         * @summary Get a participant receiver requirement schematron payload by iso number and transaction.
         * @param {string} isoNumber
         * @param {string} transactionKeyName
         * @param {string} indexOrName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getParticipantSchematronPayload: function (isoNumber, transactionKeyName, indexOrName, options) {
            return exports.ParticipantsApiFp(configuration).getParticipantSchematronPayload(isoNumber, transactionKeyName, indexOrName, options)(axios, basePath);
        },
        /**
         *
         * @summary Puts a participant business receiver requirements by iso number and transaction group.
         * @param {string} isoNumber
         * @param {string} transactionGroup
         * @param {ReceiverRequirementsMetadata} [receiverRequirements]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        putParticipantReceiverRequirementsByTransactionGroupAndIsoNumber: function (isoNumber, transactionGroup, receiverRequirements, options) {
            return exports.ParticipantsApiFp(configuration).putParticipantReceiverRequirementsByTransactionGroupAndIsoNumber(isoNumber, transactionGroup, receiverRequirements, options)(axios, basePath);
        },
        /**
         *
         * @summary Register a participant.
         * @param {string} isoNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerParticipant: function (isoNumber, options) {
            return exports.ParticipantsApiFp(configuration).registerParticipant(isoNumber, options)(axios, basePath);
        },
        /**
         * Will be deprecated later.
         * @summary Registers all transactions of a profile.
         * @param {string} isoNumber
         * @param {string} profileKeyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerTransactionsByProfile: function (isoNumber, profileKeyName, options) {
            return exports.ParticipantsApiFp(configuration).registerTransactionsByProfile(isoNumber, profileKeyName, options)(axios, basePath);
        },
        /**
         *
         * @summary Remove all registered transactions.
         * @param {string} isoNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAllParticipantTransactions: function (isoNumber, options) {
            return exports.ParticipantsApiFp(configuration).removeAllParticipantTransactions(isoNumber, options)(axios, basePath);
        },
        /**
         *
         * @summary Remove transaction for participant.
         * @param {string} isoNumber
         * @param {string} transactionKeyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAs2ParticipantTransactionsByTransactionKey: function (isoNumber, transactionKeyName, options) {
            return exports.ParticipantsApiFp(configuration).removeAs2ParticipantTransactionsByTransactionKey(isoNumber, transactionKeyName, options)(axios, basePath);
        },
        /**
         *
         * @summary Remove transaction for participant.
         * @param {string} isoNumber
         * @param {string} transactionKeyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeAs4ParticipantTransactionsByTransactionKey: function (isoNumber, transactionKeyName, options) {
            return exports.ParticipantsApiFp(configuration).removeAs4ParticipantTransactionsByTransactionKey(isoNumber, transactionKeyName, options)(axios, basePath);
        },
        /**
         *
         * @summary Remove all transaction registrations of a profile.
         * @param {string} isoNumber
         * @param {string} profileKeyName
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeParticipantTransactionsByProfile: function (isoNumber, profileKeyName, options) {
            return exports.ParticipantsApiFp(configuration).removeParticipantTransactionsByProfile(isoNumber, profileKeyName, options)(axios, basePath);
        },
        /**
         *
         * @summary Unregister and deletes participant.
         * @param {string} isoNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unregisterParticipant: function (isoNumber, options) {
            return exports.ParticipantsApiFp(configuration).unregisterParticipant(isoNumber, options)(axios, basePath);
        },
    };
};
/**
 * ParticipantsApi - object-oriented interface
 * @export
 * @class ParticipantsApi
 * @extends {BaseAPI}
 */
var ParticipantsApi = /** @class */ (function (_super) {
    __extends(ParticipantsApi, _super);
    function ParticipantsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Register a transaction.
     * @param {string} isoNumber
     * @param {string} transactionKeyName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.addAs2TransactionToParticipant = function (isoNumber, transactionKeyName, options) {
        return exports.ParticipantsApiFp(this.configuration).addAs2TransactionToParticipant(isoNumber, transactionKeyName, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Register a transaction.
     * @param {string} isoNumber
     * @param {string} transactionKeyName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.addAs4TransactionToParticipant = function (isoNumber, transactionKeyName, options) {
        return exports.ParticipantsApiFp(this.configuration).addAs4TransactionToParticipant(isoNumber, transactionKeyName, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Puts a participant business receiver requirements by iso number and transaction group.
     * @param {string} isoNumber
     * @param {string} transactionGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.deleteParticipantReceiverRequirementsByTransactionGroupAndIsoNumber = function (isoNumber, transactionGroup, options) {
        return exports.ParticipantsApiFp(this.configuration).deleteParticipantReceiverRequirementsByTransactionGroupAndIsoNumber(isoNumber, transactionGroup, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Gets all registered transactions on as2.
     * @param {string} isoNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.getAllAs2ParticipantTransactions = function (isoNumber, options) {
        return exports.ParticipantsApiFp(this.configuration).getAllAs2ParticipantTransactions(isoNumber, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Gets all registered transactions on as4.
     * @param {string} isoNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.getAllAs4ParticipantTransactions = function (isoNumber, options) {
        return exports.ParticipantsApiFp(this.configuration).getAllAs4ParticipantTransactions(isoNumber, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Gets all registered transactions of a profile.
     * @param {string} isoNumber
     * @param {string} profileKeyName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.getAllParticipantTransactionsByProfile = function (isoNumber, profileKeyName, options) {
        return exports.ParticipantsApiFp(this.configuration).getAllParticipantTransactionsByProfile(isoNumber, profileKeyName, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get participant information.
     * @param {string} isoNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.getParticipant = function (isoNumber, options) {
        return exports.ParticipantsApiFp(this.configuration).getParticipant(isoNumber, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get a participant business receiver requirements by iso number and transaction group.
     * @param {string} isoNumber
     * @param {string} transactionGroup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.getParticipantReceiverRequirementsByTransactionGroupAndIsoNumber = function (isoNumber, transactionGroup, options) {
        return exports.ParticipantsApiFp(this.configuration).getParticipantReceiverRequirementsByTransactionGroupAndIsoNumber(isoNumber, transactionGroup, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get a participant business registration by iso number.
     * @param {string} isoNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.getParticipantRegistrationByIsoNumber = function (isoNumber, options) {
        return exports.ParticipantsApiFp(this.configuration).getParticipantRegistrationByIsoNumber(isoNumber, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get a participant receiver requirement schematrons information by iso number and transaction.
     * @param {string} isoNumber
     * @param {string} transactionKeyName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.getParticipantSchematronInformation = function (isoNumber, transactionKeyName, options) {
        return exports.ParticipantsApiFp(this.configuration).getParticipantSchematronInformation(isoNumber, transactionKeyName, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Get a participant receiver requirement schematron payload by iso number and transaction.
     * @param {string} isoNumber
     * @param {string} transactionKeyName
     * @param {string} indexOrName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.getParticipantSchematronPayload = function (isoNumber, transactionKeyName, indexOrName, options) {
        return exports.ParticipantsApiFp(this.configuration).getParticipantSchematronPayload(isoNumber, transactionKeyName, indexOrName, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Puts a participant business receiver requirements by iso number and transaction group.
     * @param {string} isoNumber
     * @param {string} transactionGroup
     * @param {ReceiverRequirementsMetadata} [receiverRequirements]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.putParticipantReceiverRequirementsByTransactionGroupAndIsoNumber = function (isoNumber, transactionGroup, receiverRequirements, options) {
        return exports.ParticipantsApiFp(this.configuration).putParticipantReceiverRequirementsByTransactionGroupAndIsoNumber(isoNumber, transactionGroup, receiverRequirements, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Register a participant.
     * @param {string} isoNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.registerParticipant = function (isoNumber, options) {
        return exports.ParticipantsApiFp(this.configuration).registerParticipant(isoNumber, options)(this.axios, this.basePath);
    };
    /**
     * Will be deprecated later.
     * @summary Registers all transactions of a profile.
     * @param {string} isoNumber
     * @param {string} profileKeyName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.registerTransactionsByProfile = function (isoNumber, profileKeyName, options) {
        return exports.ParticipantsApiFp(this.configuration).registerTransactionsByProfile(isoNumber, profileKeyName, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Remove all registered transactions.
     * @param {string} isoNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.removeAllParticipantTransactions = function (isoNumber, options) {
        return exports.ParticipantsApiFp(this.configuration).removeAllParticipantTransactions(isoNumber, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Remove transaction for participant.
     * @param {string} isoNumber
     * @param {string} transactionKeyName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.removeAs2ParticipantTransactionsByTransactionKey = function (isoNumber, transactionKeyName, options) {
        return exports.ParticipantsApiFp(this.configuration).removeAs2ParticipantTransactionsByTransactionKey(isoNumber, transactionKeyName, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Remove transaction for participant.
     * @param {string} isoNumber
     * @param {string} transactionKeyName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.removeAs4ParticipantTransactionsByTransactionKey = function (isoNumber, transactionKeyName, options) {
        return exports.ParticipantsApiFp(this.configuration).removeAs4ParticipantTransactionsByTransactionKey(isoNumber, transactionKeyName, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Remove all transaction registrations of a profile.
     * @param {string} isoNumber
     * @param {string} profileKeyName
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.removeParticipantTransactionsByProfile = function (isoNumber, profileKeyName, options) {
        return exports.ParticipantsApiFp(this.configuration).removeParticipantTransactionsByProfile(isoNumber, profileKeyName, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Unregister and deletes participant.
     * @param {string} isoNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ParticipantsApi
     */
    ParticipantsApi.prototype.unregisterParticipant = function (isoNumber, options) {
        return exports.ParticipantsApiFp(this.configuration).unregisterParticipant(isoNumber, options)(this.axios, this.basePath);
    };
    return ParticipantsApi;
}(base_1.BaseAPI));
exports.ParticipantsApi = ParticipantsApi;
/**
 * ProfilesApi - axios parameter creator
 * @export
 */
exports.ProfilesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Gets all business profiles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/profiles";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Looks for a business profile by its key name.
         * @param {string} profileKeyName Business profile key name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByKeyName: function (profileKeyName, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'profileKeyName' is not null or undefined
            if (profileKeyName === null || profileKeyName === undefined) {
                throw new base_1.RequiredError('profileKeyName', 'Required parameter profileKeyName was null or undefined when calling getByKeyName.');
            }
            var localVarPath = "/api/v1/profiles/{profileKeyName}"
                .replace("{" + "profileKeyName" + "}", encodeURIComponent(String(profileKeyName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * ProfilesApi - functional programming interface
 * @export
 */
exports.ProfilesApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Gets all business profiles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (options) {
            var localVarAxiosArgs = exports.ProfilesApiAxiosParamCreator(configuration).get(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Looks for a business profile by its key name.
         * @param {string} profileKeyName Business profile key name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByKeyName: function (profileKeyName, options) {
            var localVarAxiosArgs = exports.ProfilesApiAxiosParamCreator(configuration).getByKeyName(profileKeyName, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * ProfilesApi - factory interface
 * @export
 */
exports.ProfilesApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Gets all business profiles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (options) {
            return exports.ProfilesApiFp(configuration).get(options)(axios, basePath);
        },
        /**
         *
         * @summary Looks for a business profile by its key name.
         * @param {string} profileKeyName Business profile key name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByKeyName: function (profileKeyName, options) {
            return exports.ProfilesApiFp(configuration).getByKeyName(profileKeyName, options)(axios, basePath);
        },
    };
};
/**
 * ProfilesApi - object-oriented interface
 * @export
 * @class ProfilesApi
 * @extends {BaseAPI}
 */
var ProfilesApi = /** @class */ (function (_super) {
    __extends(ProfilesApi, _super);
    function ProfilesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Gets all business profiles.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    ProfilesApi.prototype.get = function (options) {
        return exports.ProfilesApiFp(this.configuration).get(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Looks for a business profile by its key name.
     * @param {string} profileKeyName Business profile key name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfilesApi
     */
    ProfilesApi.prototype.getByKeyName = function (profileKeyName, options) {
        return exports.ProfilesApiFp(this.configuration).getByKeyName(profileKeyName, options)(this.axios, this.basePath);
    };
    return ProfilesApi;
}(base_1.BaseAPI));
exports.ProfilesApi = ProfilesApi;
/**
 * RegionApi - axios parameter creator
 * @export
 */
exports.RegionApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Gets all region country associations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegionCountryAssociations: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/regionCountryAssociations";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets all region validations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegionValidations: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/regionValidations";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets all regions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegions: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/regions";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RegionApi - functional programming interface
 * @export
 */
exports.RegionApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Gets all region country associations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegionCountryAssociations: function (options) {
            var localVarAxiosArgs = exports.RegionApiAxiosParamCreator(configuration).getRegionCountryAssociations(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Gets all region validations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegionValidations: function (options) {
            var localVarAxiosArgs = exports.RegionApiAxiosParamCreator(configuration).getRegionValidations(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Gets all regions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegions: function (options) {
            var localVarAxiosArgs = exports.RegionApiAxiosParamCreator(configuration).getRegions(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * RegionApi - factory interface
 * @export
 */
exports.RegionApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Gets all region country associations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegionCountryAssociations: function (options) {
            return exports.RegionApiFp(configuration).getRegionCountryAssociations(options)(axios, basePath);
        },
        /**
         *
         * @summary Gets all region validations.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegionValidations: function (options) {
            return exports.RegionApiFp(configuration).getRegionValidations(options)(axios, basePath);
        },
        /**
         *
         * @summary Gets all regions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRegions: function (options) {
            return exports.RegionApiFp(configuration).getRegions(options)(axios, basePath);
        },
    };
};
/**
 * RegionApi - object-oriented interface
 * @export
 * @class RegionApi
 * @extends {BaseAPI}
 */
var RegionApi = /** @class */ (function (_super) {
    __extends(RegionApi, _super);
    function RegionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Gets all region country associations.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegionApi
     */
    RegionApi.prototype.getRegionCountryAssociations = function (options) {
        return exports.RegionApiFp(this.configuration).getRegionCountryAssociations(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Gets all region validations.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegionApi
     */
    RegionApi.prototype.getRegionValidations = function (options) {
        return exports.RegionApiFp(this.configuration).getRegionValidations(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Gets all regions.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RegionApi
     */
    RegionApi.prototype.getRegions = function (options) {
        return exports.RegionApiFp(this.configuration).getRegions(options)(this.axios, this.basePath);
    };
    return RegionApi;
}(base_1.BaseAPI));
exports.RegionApi = RegionApi;
/**
 * RequirementsApi - axios parameter creator
 * @export
 */
exports.RequirementsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary .
         * @param {string} isoNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequirements: function (isoNumber, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'isoNumber' is not null or undefined
            if (isoNumber === null || isoNumber === undefined) {
                throw new base_1.RequiredError('isoNumber', 'Required parameter isoNumber was null or undefined when calling getRequirements.');
            }
            var localVarPath = "/api/v1/requirements/{isoNumber}"
                .replace("{" + "isoNumber" + "}", encodeURIComponent(String(isoNumber)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary .
         * @param {string} isoNumber
         * @param {string} fieldName
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [textFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValuesOfRequirements: function (isoNumber, fieldName, offset, limit, textFilter, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'isoNumber' is not null or undefined
            if (isoNumber === null || isoNumber === undefined) {
                throw new base_1.RequiredError('isoNumber', 'Required parameter isoNumber was null or undefined when calling getValuesOfRequirements.');
            }
            // verify required parameter 'fieldName' is not null or undefined
            if (fieldName === null || fieldName === undefined) {
                throw new base_1.RequiredError('fieldName', 'Required parameter fieldName was null or undefined when calling getValuesOfRequirements.');
            }
            var localVarPath = "/api/v1/requirements/{isoNumber}/{fieldName}/values"
                .replace("{" + "isoNumber" + "}", encodeURIComponent(String(isoNumber)))
                .replace("{" + "fieldName" + "}", encodeURIComponent(String(fieldName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (offset !== undefined) {
                localVarQueryParameter['Offset'] = offset;
            }
            if (limit !== undefined) {
                localVarQueryParameter['Limit'] = limit;
            }
            if (textFilter !== undefined) {
                localVarQueryParameter['textFilter'] = textFilter;
            }
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RequirementsApi - functional programming interface
 * @export
 */
exports.RequirementsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary .
         * @param {string} isoNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequirements: function (isoNumber, options) {
            var localVarAxiosArgs = exports.RequirementsApiAxiosParamCreator(configuration).getRequirements(isoNumber, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary .
         * @param {string} isoNumber
         * @param {string} fieldName
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [textFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValuesOfRequirements: function (isoNumber, fieldName, offset, limit, textFilter, options) {
            var localVarAxiosArgs = exports.RequirementsApiAxiosParamCreator(configuration).getValuesOfRequirements(isoNumber, fieldName, offset, limit, textFilter, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * RequirementsApi - factory interface
 * @export
 */
exports.RequirementsApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary .
         * @param {string} isoNumber
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRequirements: function (isoNumber, options) {
            return exports.RequirementsApiFp(configuration).getRequirements(isoNumber, options)(axios, basePath);
        },
        /**
         *
         * @summary .
         * @param {string} isoNumber
         * @param {string} fieldName
         * @param {number} [offset]
         * @param {number} [limit]
         * @param {string} [textFilter]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValuesOfRequirements: function (isoNumber, fieldName, offset, limit, textFilter, options) {
            return exports.RequirementsApiFp(configuration).getValuesOfRequirements(isoNumber, fieldName, offset, limit, textFilter, options)(axios, basePath);
        },
    };
};
/**
 * RequirementsApi - object-oriented interface
 * @export
 * @class RequirementsApi
 * @extends {BaseAPI}
 */
var RequirementsApi = /** @class */ (function (_super) {
    __extends(RequirementsApi, _super);
    function RequirementsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary .
     * @param {string} isoNumber
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequirementsApi
     */
    RequirementsApi.prototype.getRequirements = function (isoNumber, options) {
        return exports.RequirementsApiFp(this.configuration).getRequirements(isoNumber, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary .
     * @param {string} isoNumber
     * @param {string} fieldName
     * @param {number} [offset]
     * @param {number} [limit]
     * @param {string} [textFilter]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RequirementsApi
     */
    RequirementsApi.prototype.getValuesOfRequirements = function (isoNumber, fieldName, offset, limit, textFilter, options) {
        return exports.RequirementsApiFp(this.configuration).getValuesOfRequirements(isoNumber, fieldName, offset, limit, textFilter, options)(this.axios, this.basePath);
    };
    return RequirementsApi;
}(base_1.BaseAPI));
exports.RequirementsApi = RequirementsApi;
/**
 * RolesApi - axios parameter creator
 * @export
 */
exports.RolesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Gets all business roles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/roles";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RolesApi - functional programming interface
 * @export
 */
exports.RolesApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Gets all business roles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (options) {
            var localVarAxiosArgs = exports.RolesApiAxiosParamCreator(configuration).get(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * RolesApi - factory interface
 * @export
 */
exports.RolesApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Gets all business roles.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (options) {
            return exports.RolesApiFp(configuration).get(options)(axios, basePath);
        },
    };
};
/**
 * RolesApi - object-oriented interface
 * @export
 * @class RolesApi
 * @extends {BaseAPI}
 */
var RolesApi = /** @class */ (function (_super) {
    __extends(RolesApi, _super);
    function RolesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Gets all business roles.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesApi
     */
    RolesApi.prototype.get = function (options) {
        return exports.RolesApiFp(this.configuration).get(options)(this.axios, this.basePath);
    };
    return RolesApi;
}(base_1.BaseAPI));
exports.RolesApi = RolesApi;
/**
 * RootApi - axios parameter creator
 * @export
 */
exports.RootApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Root resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoot: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * RootApi - functional programming interface
 * @export
 */
exports.RootApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Root resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoot: function (options) {
            var localVarAxiosArgs = exports.RootApiAxiosParamCreator(configuration).getRoot(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * RootApi - factory interface
 * @export
 */
exports.RootApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Root resource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoot: function (options) {
            return exports.RootApiFp(configuration).getRoot(options)(axios, basePath);
        },
    };
};
/**
 * RootApi - object-oriented interface
 * @export
 * @class RootApi
 * @extends {BaseAPI}
 */
var RootApi = /** @class */ (function (_super) {
    __extends(RootApi, _super);
    function RootApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Root resource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RootApi
     */
    RootApi.prototype.getRoot = function (options) {
        return exports.RootApiFp(this.configuration).getRoot(options)(this.axios, this.basePath);
    };
    return RootApi;
}(base_1.BaseAPI));
exports.RootApi = RootApi;
/**
 * TransactionGroupsApi - axios parameter creator
 * @export
 */
exports.TransactionGroupsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Gets all business transaction groups.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/transaction-groups";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TransactionGroupsApi - functional programming interface
 * @export
 */
exports.TransactionGroupsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Gets all business transaction groups.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (options) {
            var localVarAxiosArgs = exports.TransactionGroupsApiAxiosParamCreator(configuration).get(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * TransactionGroupsApi - factory interface
 * @export
 */
exports.TransactionGroupsApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Gets all business transaction groups.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (options) {
            return exports.TransactionGroupsApiFp(configuration).get(options)(axios, basePath);
        },
    };
};
/**
 * TransactionGroupsApi - object-oriented interface
 * @export
 * @class TransactionGroupsApi
 * @extends {BaseAPI}
 */
var TransactionGroupsApi = /** @class */ (function (_super) {
    __extends(TransactionGroupsApi, _super);
    function TransactionGroupsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Gets all business transaction groups.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionGroupsApi
     */
    TransactionGroupsApi.prototype.get = function (options) {
        return exports.TransactionGroupsApiFp(this.configuration).get(options)(this.axios, this.basePath);
    };
    return TransactionGroupsApi;
}(base_1.BaseAPI));
exports.TransactionGroupsApi = TransactionGroupsApi;
/**
 * TransactionsApi - axios parameter creator
 * @export
 */
exports.TransactionsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @summary Gets all transactions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/transactions";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets a transaction with the specified key name.
         * @param {string} transactionKeyName Transaction key name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByTransactionKeyName: function (transactionKeyName, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'transactionKeyName' is not null or undefined
            if (transactionKeyName === null || transactionKeyName === undefined) {
                throw new base_1.RequiredError('transactionKeyName', 'Required parameter transactionKeyName was null or undefined when calling getByTransactionKeyName.');
            }
            var localVarPath = "/api/v1/transactions/{transactionKeyName}"
                .replace("{" + "transactionKeyName" + "}", encodeURIComponent(String(transactionKeyName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets all transactions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionFields: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1/transactions/fields";
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets transactions with the specified profile key name.
         * @param {string} profileKeyName Profile key name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsByProfileKeyName: function (profileKeyName, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'profileKeyName' is not null or undefined
            if (profileKeyName === null || profileKeyName === undefined) {
                throw new base_1.RequiredError('profileKeyName', 'Required parameter profileKeyName was null or undefined when calling getTransactionsByProfileKeyName.');
            }
            var localVarPath = "/api/v1/profiles/{profileKeyName}/transactions"
                .replace("{" + "profileKeyName" + "}", encodeURIComponent(String(profileKeyName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @summary Gets transactions with the specified transaction group key name.
         * @param {string} transactionGroupKeyName Transaction group key name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsByTransactionGroupKeyName: function (transactionGroupKeyName, options) {
            if (options === void 0) { options = {}; }
            // verify required parameter 'transactionGroupKeyName' is not null or undefined
            if (transactionGroupKeyName === null || transactionGroupKeyName === undefined) {
                throw new base_1.RequiredError('transactionGroupKeyName', 'Required parameter transactionGroupKeyName was null or undefined when calling getTransactionsByTransactionGroupKeyName.');
            }
            var localVarPath = "/api/v1/transaction-groups/{transactionGroupKeyName}/transactions"
                .replace("{" + "transactionGroupKeyName" + "}", encodeURIComponent(String(transactionGroupKeyName)));
            var localVarUrlObj = globalImportUrl.parse(localVarPath, true);
            var baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            var localVarRequestOptions = __assign({ method: 'GET' }, baseOptions, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            localVarUrlObj.query = __assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = __assign({}, localVarHeaderParameter, options.headers);
            return {
                url: globalImportUrl.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * TransactionsApi - functional programming interface
 * @export
 */
exports.TransactionsApiFp = function (configuration) {
    return {
        /**
         *
         * @summary Gets all transactions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (options) {
            var localVarAxiosArgs = exports.TransactionsApiAxiosParamCreator(configuration).get(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Gets a transaction with the specified key name.
         * @param {string} transactionKeyName Transaction key name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByTransactionKeyName: function (transactionKeyName, options) {
            var localVarAxiosArgs = exports.TransactionsApiAxiosParamCreator(configuration).getByTransactionKeyName(transactionKeyName, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Gets all transactions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionFields: function (options) {
            var localVarAxiosArgs = exports.TransactionsApiAxiosParamCreator(configuration).getTransactionFields(options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Gets transactions with the specified profile key name.
         * @param {string} profileKeyName Profile key name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsByProfileKeyName: function (profileKeyName, options) {
            var localVarAxiosArgs = exports.TransactionsApiAxiosParamCreator(configuration).getTransactionsByProfileKeyName(profileKeyName, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         *
         * @summary Gets transactions with the specified transaction group key name.
         * @param {string} transactionGroupKeyName Transaction group key name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsByTransactionGroupKeyName: function (transactionGroupKeyName, options) {
            var localVarAxiosArgs = exports.TransactionsApiAxiosParamCreator(configuration).getTransactionsByTransactionGroupKeyName(transactionGroupKeyName, options);
            return function (axios, basePath) {
                if (axios === void 0) { axios = axios_1.default; }
                if (basePath === void 0) { basePath = base_1.BASE_PATH; }
                var axiosRequestArgs = __assign({}, localVarAxiosArgs.options, { url: basePath + localVarAxiosArgs.url });
                return axios.request(axiosRequestArgs);
            };
        },
    };
};
/**
 * TransactionsApi - factory interface
 * @export
 */
exports.TransactionsApiFactory = function (configuration, basePath, axios) {
    return {
        /**
         *
         * @summary Gets all transactions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        get: function (options) {
            return exports.TransactionsApiFp(configuration).get(options)(axios, basePath);
        },
        /**
         *
         * @summary Gets a transaction with the specified key name.
         * @param {string} transactionKeyName Transaction key name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getByTransactionKeyName: function (transactionKeyName, options) {
            return exports.TransactionsApiFp(configuration).getByTransactionKeyName(transactionKeyName, options)(axios, basePath);
        },
        /**
         *
         * @summary Gets all transactions.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionFields: function (options) {
            return exports.TransactionsApiFp(configuration).getTransactionFields(options)(axios, basePath);
        },
        /**
         *
         * @summary Gets transactions with the specified profile key name.
         * @param {string} profileKeyName Profile key name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsByProfileKeyName: function (profileKeyName, options) {
            return exports.TransactionsApiFp(configuration).getTransactionsByProfileKeyName(profileKeyName, options)(axios, basePath);
        },
        /**
         *
         * @summary Gets transactions with the specified transaction group key name.
         * @param {string} transactionGroupKeyName Transaction group key name.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionsByTransactionGroupKeyName: function (transactionGroupKeyName, options) {
            return exports.TransactionsApiFp(configuration).getTransactionsByTransactionGroupKeyName(transactionGroupKeyName, options)(axios, basePath);
        },
    };
};
/**
 * TransactionsApi - object-oriented interface
 * @export
 * @class TransactionsApi
 * @extends {BaseAPI}
 */
var TransactionsApi = /** @class */ (function (_super) {
    __extends(TransactionsApi, _super);
    function TransactionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Gets all transactions.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    TransactionsApi.prototype.get = function (options) {
        return exports.TransactionsApiFp(this.configuration).get(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Gets a transaction with the specified key name.
     * @param {string} transactionKeyName Transaction key name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    TransactionsApi.prototype.getByTransactionKeyName = function (transactionKeyName, options) {
        return exports.TransactionsApiFp(this.configuration).getByTransactionKeyName(transactionKeyName, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Gets all transactions.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    TransactionsApi.prototype.getTransactionFields = function (options) {
        return exports.TransactionsApiFp(this.configuration).getTransactionFields(options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Gets transactions with the specified profile key name.
     * @param {string} profileKeyName Profile key name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    TransactionsApi.prototype.getTransactionsByProfileKeyName = function (profileKeyName, options) {
        return exports.TransactionsApiFp(this.configuration).getTransactionsByProfileKeyName(profileKeyName, options)(this.axios, this.basePath);
    };
    /**
     *
     * @summary Gets transactions with the specified transaction group key name.
     * @param {string} transactionGroupKeyName Transaction group key name.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TransactionsApi
     */
    TransactionsApi.prototype.getTransactionsByTransactionGroupKeyName = function (transactionGroupKeyName, options) {
        return exports.TransactionsApiFp(this.configuration).getTransactionsByTransactionGroupKeyName(transactionGroupKeyName, options)(this.axios, this.basePath);
    };
    return TransactionsApi;
}(base_1.BaseAPI));
exports.TransactionsApi = TransactionsApi;
